import appStore                         from '@/stores/appStore';
import { observer }                     from 'mobx-react-lite';
import React                            from 'react';
import View                             from '@widesk-ui/components/View';
import Link                             from '@widesk-ui/components/Link';
import Card                             from '@widesk-ui/components/Card';
import WebsiteEntertainmentModel        from '@models/website/WebsiteEntertainmentModel';
import { pathWithWebsiteEntertainment } from '@/hooks/useWebsiteEntertainment';
import WebsitePublicModelImage          from '@/components/WebsitePublicModelImage';

export type ContextValue = {
	websiteEntertainment: WebsiteEntertainmentModel | 'all' | null;
};

export const WebsiteEntertainmentContext = React.createContext<ContextValue>({} as ContextValue);

export type EntertainmentProviderProps = React.PropsWithChildren;

const WebsiteEntertainmentProvider = observer(({ children }: EntertainmentProviderProps) => {
	const { websiteEntertainment } = appStore;

	if (!websiteEntertainment) {
		return (
			<View row gap="md" p="md" wrap>
				{appStore.collWebsiteEntertainment.map(we => {
					return (
						<Link to={pathWithWebsiteEntertainment('/home', we.id)} key={we.id}>
							<Card hoverable variant="outlined">
								<View w={150} h={150} center bold align="center" gap="sm">
									<WebsitePublicModelImage
										model={we}
										preview={false}
										reference="website_entertainment_sidebar_image"
										size="large"
										style={{ borderRadius: 4 }}
									/>

									{we.renderName()}
									{we.websiteEntertainmentStatus.renderName()}
								</View>
							</Card>
						</Link>
					);
				})}
			</View>
		);
	}

	return (
		<WebsiteEntertainmentContext.Provider value={{ websiteEntertainment: websiteEntertainment }}>
			{children}
		</WebsiteEntertainmentContext.Provider>
	);
});

export default WebsiteEntertainmentProvider;
